<template>
  <el-form ref="form" size="mini" label-position="right" label-width="150px" class="demo-form-inline"
    :model="examBasicQuery" :disabled="disabled">

    <h4>一、家族遗传史</h4>
    <el-form-item label="家族冠心病：">
      <div class="container">
        <el-radio-group v-model="showParentsCad" @change="handleShowParentsCadChange">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
        <el-checkbox-group v-if="showParentsCad" v-model="has.selectedParentsCad">
          <el-checkbox label="父系">父系</el-checkbox>
          <el-checkbox label="母系">母系</el-checkbox>
        </el-checkbox-group>
      </div>
    </el-form-item>

    <el-form-item label="家族心梗史：">
      <div class="container">
        <el-radio-group v-model="showParentsMac" @change="handleShowParentsMacChange">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
        <el-checkbox-group v-if="showParentsMac" v-model="has.selectedParentsMac">
          <el-checkbox label="父系">父系</el-checkbox>
          <el-checkbox label="母系">母系</el-checkbox>
        </el-checkbox-group>
      </div>
    </el-form-item>

    <el-form-item label="其他：">
      <el-input v-model="examBasicQuery.familyOther" />
    </el-form-item>

    <h4> 二．既往病史及临床检查报告：</h4>
    <el-form-item label="高血压：">
      <el-col :span="4">
        <el-radio-group v-model="has.pastHighPress">
          <el-radio label="否">否</el-radio>
          <el-radio label="是">是</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.pastHighPress" :disabled="has.pastHighPress === '否'">
          <template slot="append">年（时长）</template>
        </el-input>
      </el-col>
    </el-form-item>

    <el-form-item label="糖尿病：">
      <el-col :span="4">
        <el-radio-group v-model="has.pastDiabetes">
          <el-radio label="否">否</el-radio>
          <el-radio label="是">是</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.pastDiabetes" :disabled="has.pastDiabetes === '否'">
          <template slot="append">年（时长）</template>
        </el-input>
      </el-col>
    </el-form-item>

    <el-form-item label="高血脂：">
      <el-col :span="4">
        <el-radio-group v-model="has.pastHyperlipidemia">
          <el-radio label="否">否</el-radio>
          <el-radio label="是">是</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.pastHyperlipidemia" :disabled="has.pastHyperlipidemia === '否'">
          <template slot="append">年（时长）</template>
        </el-input>
      </el-col>
    </el-form-item>

    <el-form-item label="脂肪肝：">
      <el-col :span="4">
        <el-radio-group v-model="has.pastFattyLiver">
          <el-radio label="否">否</el-radio>
          <el-radio label="是">是</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.pastFattyLiver" :disabled="has.pastFattyLiver === '否'">
          <template slot="append">年（时长）</template>
        </el-input>
      </el-col>
    </el-form-item>

    <el-form-item label="冠心病：">
      <el-col :span="4">
        <el-radio-group v-model="has.pastCad">
          <el-radio label="否">否</el-radio>
          <el-radio label="是">是</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.pastCad" :disabled="has.pastCad === '否'">
          <template slot="append">年（时长）</template>
        </el-input>
      </el-col>
    </el-form-item>

    <el-form-item label="心脏手术史：">
      <el-col :span="16">
        <div class="container">
          <el-radio-group v-model="hadHeartOp">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
          <div v-if="hadHeartOp" class="checkbox-container">
            <div class="checkbox-item" v-for="(value, key) in has.pastStentImplantation" :key="key">
              <el-input v-model="has.pastStentImplantation[key]" placeholder="整数时长（1~70）">
                <template #prepend>
                  <div style="width: 80px;">
                    <span>{{ key }}</span>
                  </div>

                </template>
                <template #append>年（时长）</template>
              </el-input>
            </div>
          </div>
        </div>
      </el-col>

    </el-form-item>

    <el-form-item label="您是否通过医院检查明确诊断某种疾病?">
      <el-radio-group v-model="hadConfirmedDesease">
        <el-radio :label="false">否</el-radio>
        <el-radio :label="true">是</el-radio>
      </el-radio-group>
      <el-checkbox-group :disabled="!hadConfirmedDesease" v-model="has.hospitalConfirmedDiseasArr">
        <el-checkbox label="心律不齐/心律失常"></el-checkbox>
        <el-checkbox label="心肌炎"></el-checkbox>
        <el-checkbox label="心肌桥"></el-checkbox>
        <el-checkbox label="心肌病"></el-checkbox>
        <el-checkbox label="心脏瓣膜疾病"></el-checkbox>
        <el-checkbox label="心衰"></el-checkbox>
        <el-checkbox label="心梗"></el-checkbox>
        <el-checkbox label="其他"></el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="其他：">
      <el-input v-model="has.pastOtherDisease" :disabled="otherHospitalConfirmedDiseasDisabled" />
    </el-form-item>
    <el-form-item label="临床检查报告：">
      <el-radio-group v-model="hadClinlicReport">
        <el-radio :label="false">无</el-radio>
        <el-radio :label="true">有</el-radio>
      </el-radio-group>
      <div>
        <el-checkbox-group v-if="hadClinlicReport" v-model="hospitalExamReport" class="column-checkbox-group">
          <el-checkbox v-for="option in has.relatedHospitalReportArr" :key="option.label" :label="option.label"
            class="row-checkbox">
            <div class="row-content">
              <label class="checkbox-label">{{ option.label }}</label>
              <el-input placeholder="检测结论" v-model="option.conclution" class="conclusion-input" />

              <el-upload class="upload-demo upload-button" :action="upload4Cospath('pdf')" :on-preview="handlePreview"
                accept="application/pdf" :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1"
                :on-exceed="handleExceed" :auto-upload="true" :on-success="(value) => option.url = value.data[0]"
                :file-list="[]">
                <el-button size="mini" type="primary">点击上传</el-button>
              </el-upload>
              <a :href="option.url" v-if="option.url !== ''" target="_blank" class="report-link">下载查看</a>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </el-form-item>

    <h4>三．症状体征： </h4>
    <el-form-item label="胸闷：">
      <el-radio-group v-model="examBasicQuery.bodyProblemChestDistress">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="胸痛：">
      <el-radio-group v-model="examBasicQuery.bodyProblemChestAche">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="肩背痛：">
      <el-radio-group v-model="examBasicQuery.bodyProblemBackAche">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="眩晕：">
      <el-radio-group v-model="examBasicQuery.bodyProblemDizzle">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="心悸：">
      <el-radio-group v-model="examBasicQuery.bodyProblemPalpitation">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="气短：">
      <el-radio-group v-model="examBasicQuery.bodyProblemBreatheHard">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="神疲乏力：">
      <el-radio-group v-model="examBasicQuery.bodyProblemWeary">
        <el-radio label="0" key="0">从不</el-radio>
        <el-radio label="1" key="1">偶尔</el-radio>
        <el-radio label="2" key="2">经常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="月经：">
      <el-radio-group v-model="examBasicQuery.bodyProplemMenstruation" :disabled="!isFemale">
        <el-radio label="0" key="0">量少</el-radio>
        <el-radio label="1" key="1">一般</el-radio>
        <el-radio label="2" key="2">量多</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="其他：">
      <el-input v-model="examBasicQuery.bodyProblemOther" />
    </el-form-item>
    <h4>四．服药史：</h4>
    <el-form-item label="服药史：">
      <el-radio-group v-model="has.medicalHistory.had">
        <el-radio :label="false">否</el-radio>
        <el-radio :label="true">是</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="药物名称：">
      <el-checkbox-group v-show="has.medicalHistory.had || has.medicalHistory.had === 'true'"
        v-model="has.medicalHistory.med">
        <el-checkbox label="阿司匹林"></el-checkbox>
        <el-checkbox label="氯吡格雷"></el-checkbox>
        <el-checkbox label="美托洛尔"></el-checkbox>
        <el-checkbox label="索洛尔"></el-checkbox>
        <el-checkbox label="阿托伐他汀"></el-checkbox>
        <el-checkbox label="瑞舒伐他汀"></el-checkbox>
        <el-checkbox label="辛伐他汀"></el-checkbox>
        <el-checkbox label="替米沙坦"></el-checkbox>
        <el-checkbox label="卡托普利 "></el-checkbox>
        <el-checkbox label="依那普利"></el-checkbox>
        <el-checkbox label="厄贝沙坦"></el-checkbox>
        <el-checkbox label="缬沙坦"></el-checkbox>
        <el-checkbox label="氯沙坦"></el-checkbox>
        <el-checkbox label="沙库巴曲/缬沙坦 "></el-checkbox>
        <el-checkbox label="硝苯地平"></el-checkbox>
        <el-checkbox label="氨氯地平"></el-checkbox>
        <el-checkbox label="速效救心丸"></el-checkbox>
        <el-checkbox label="复方丹参滴丸"></el-checkbox>
        <el-checkbox label="硝酸甘油"></el-checkbox>
        <el-checkbox label="硝酸异山梨酯"></el-checkbox>
        <el-checkbox label="曲美他嗪"></el-checkbox>
        <el-checkbox label="尼可地尔"></el-checkbox>
        <br />
        <el-checkbox label="其他"></el-checkbox>
        <el-input v-show="has.medicalHistory.med.includes('其他')" placeholder="药物名称"
          v-model="has.medicalHistory.other"></el-input>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="保健品/药膳：">
      <el-radio-group v-model="has.healthCareProduct">
        <el-radio label="否" key="否"></el-radio>
        <el-radio label="是" key="是"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="has.healthCareProduct === '是'" label="保健品名称：">
      <el-input v-model="examBasicQuery.healthCareProduct" />
    </el-form-item>
    <h4>五．基础检查</h4>
    <el-form-item label="血压：">
      <el-col :span="4">
        <span>（收缩压/舒张压）</span>
      </el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.bloodPressureHigh" type="number" class="no-spinner">
        </el-input>
      </el-col>
      <el-col :span="1" class="text-center">/</el-col>
      <el-col :span="4">
        <el-input v-model="examBasicQuery.bloodPressureLow" type="number" class="no-spinner">
        </el-input>
      </el-col>
      <el-col :span="4">
        <span>mmHg</span>
      </el-col>
      <el-col v-if="showBloodPressureWarning" :span="4">
        <span style="color:red;font-weight: 800" >注意：血压异常</span>
      </el-col>
    </el-form-item>

    <el-form-item label="血氧饱和度：">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.spoz" type="number">
          <template slot="append">%</template>
        </el-input>
      </el-col>
    </el-form-item>

    <el-form-item label="心率：">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.heartRate" type="number">
          <template slot="append">次/分</template>
        </el-input>
      </el-col>
      <el-col v-if="showheartRateWarning" :span="4">
        <span style="color:red;font-weight: 800" >注意：心率异常</span>
      </el-col>
    </el-form-item>
    <el-form-item label="BMI：">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bmi" type="number">
          <template slot="append">kg/m²</template>
        </el-input>
      </el-col>
    </el-form-item>
    <el-form-item label="血糖：">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodSugar" type="number">
          <template slot="append">mmol/L</template>
        </el-input>
      </el-col>
      <el-col v-if="showBloodSugarWarning" :span="4">
        <span style="color:red;font-weight: 800" >注意：血糖异常</span>
      </el-col>
      <el-col :span="20" style="margin-left: 15px">
        <el-radio-group v-model="bloodSugarTime">
          <el-radio label="随机"></el-radio>
          <el-radio label="空腹"></el-radio>
          <el-radio label="餐后1小时"></el-radio>
          <el-radio label="餐后2小时"></el-radio>
        </el-radio-group>
      </el-col>

    </el-form-item>

    <div v-if="false">
    <h5 class="indent">血脂全套</h5>
    <el-form-item label="总胆固醇 (TC)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatTc" type="number">
          <template slot="append">mmol/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：3.1-5.70 mmol/L
      </el-col>
    </el-form-item>
    <el-form-item label="甘油三酯( TG)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatTg" type="number">
          <template slot="append">mmol/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：0.56-1.70 mmol/L
      </el-col>
    </el-form-item>
    <el-form-item label="高密度脂蛋白胆固醇 (HDL-C)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatHdlC" type="number">
          <template slot="append">mmol/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：0.91-2.28 mmol/L
      </el-col>
    </el-form-item>
    <el-form-item label="低密度脂蛋白胆固醇 (LDL-C)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatLdlC" type="number">
          <template slot="append">mmol/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：1.90-3.60 mmol/L
      </el-col>
    </el-form-item>
    <el-form-item label="载脂蛋白 AI(APO AI)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatApoaI" type="number">
          <template slot="append">g/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：1.20-1.76 g/L
      </el-col>
    </el-form-item>
    <el-form-item label="载脂蛋白 B (APO B)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatApob" type="number">
          <template slot="append">g/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：0.63-1.14 g/L
      </el-col>
    </el-form-item>
    <el-form-item label="脂蛋白(a) (Lp(a))：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.bloodFatLpA" type="number">
          <template slot="append">mg/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：0-300 mg/Le
      </el-col>
    </el-form-item>

    <h5 class="indent">心肌三项</h5>
    <el-form-item label="肌酸激酶同工酶 MB (CK-MB)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.cardiacMuscle3Ckmb" type="number">
          <template slot="append">ng/mL</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：&lt; 6.3 ng/ml
      </el-col>
    </el-form-item>
    <el-form-item label="心肌肌钙蛋白 I (cTnl)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.cardiacMuscle3Ctnl" type="number">
          <template slot="append">ng/mL</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：&lt; 0.04 ng/ml
      </el-col>
    </el-form-item>
    <el-form-item label="肌红蛋白 (Myo)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.cardiacMuscle3Myo" type="number">
          <template slot="append">ng/mL</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：&lt; 70.00 ng/ml
      </el-col>
    </el-form-item>
    <h5 class="indent">心肌酶谱</h5>
    <el-form-item label="乳酸脱氢酶 (LD)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.myocardialEnzymeLdh" type="number">
          <template slot="append">U/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：40-240 U/L
      </el-col>
    </el-form-item>
    <el-form-item label="肌酸激酶 (CK)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.myocardialEnzymeCk" type="number">
          <template slot="append">U/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：20-190 U/L
      </el-col>
    </el-form-item>
    <el-form-item label="α-羟丁酸脱氢酶 (α-HBDH)：" :label-width="fixedLabelWidth1">
      <el-col :span="8">
        <el-input v-model="examBasicQuery.myocardialEnzymeHbdh" type="number">
          <template slot="append">U/L</template>
        </el-input>
      </el-col>
      <el-col :span="8" class="ml15">
        正常范围值：80-200 U/L
      </el-col>
    </el-form-item>
    </div>
    <el-form-item>
      <el-button :loading="submitting" type="primary" @click="_updateExamBasicQuery" class="fullWidth" size="medium"
        v-show="!disabled">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { baseURL } from "../../api/axiosCreator";
import {
  getExamBasicQuery,
  updateExamBasicQuery,
  updateExamState,
} from "../../api/userExamService";
import {
  ExamStatesValue,
  Personalities
} from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";

const hospitalConfirmedDiseasOptions = [
  "心律不齐/心律失常",
  "心肌炎",
  "心肌桥",
  "心肌病",
  "心脏瓣膜疾病",
  "心衰",
  "心梗",
  "其他"
]
const relatedHospitalReportOptions = [
  "心电图",
  "运动平板",
  "心肺运动试验",
  "超声波心动图",
  "冠脉CTA",
  "冠脉CAG",
  "核素心肌灌注显像",
  "其他"
]

const NoPastStentImplantation = {
  "球囊括张术": 0,
  "支架植入术": 0,
  "搭桥术": 0,
  "起搏器植入术": 0,
  "射频消融术": 0
}

const MedicalHistory =
{
  "had": false,
  "med": [],
  "other": ""
}

const ClinicReport = [
  {
    label: "心电图",
    url: "",
    conclution: ""
  },
  {
    label: "运动平板",
    url: "",
    conclution: ""
  },
  {
    label: "心肺运动试验",
    url: "",
    conclution: ""
  },
  {
    label: "超声心动图",
    url: "",
    conclution: ""
  },
  {
    label: "冠脉CTA",
    url: "",
    conclution: ""
  },
  {
    label: "冠脉CAG",
    url: "",
    conclution: ""
  },
  {
    label: "核素心肌灌注显像",
    url: "",
    conclution: ""
  },
  {
    label: "其他",
    url: "",
    conclution: ""
  }
]

export default {
  name: "BasicQuery",
  props: {
    examUuid: String,
    disabled: Boolean,
  },
  data() {
    return {
      showParentsCad: false,
      showParentsMac: false,
      hadHeartOp: false,
      hadConfirmedDesease: false,
      hadClinlicReport: false,
      fixedLabelWidth1: '220px',
      submitting: false,
      Personalities,
      bloodSugarTime:'随机',
      showBloodPressureWarning: false,
      showheartRateWarning: false,
      showBloodSugarWarning: false,
      hospitalExamReport: [],
      //isFemale: sessionStorage.getItem('userInfo').gender === '女',
      //基础问询-前端格式
      examBasicQuery: {
        "examUuid": "",
        "familyCad": "", //#遗传 冠心病，空表示无
        "familyMac": "",//#遗传 心梗
        "familyOther": "",//#遗传其他
        "pastHighPress": "",//#既往高血压，数据表年限，0表无
        "pastDiabetes": "",//#既往糖尿病，数据表年限，0表无
        "pastHyperlipidemia": "",//#既往高血脂，数据表年限，0表无
        "pastFattyLiver": "",///#既往脂肪肝，数据表年限，0表无
        "pastCad": "",//#既往冠心病，数据表年限，0表无
        "pastStentImplantation": "",//#既往支架，0表示无
        // "pastOtherDiseas": "",//既往其他病，字符串
        "hospitalConfirmedDiseas": "",
        "relatedHospitalReport": "",
        "bodyProblemChestDistress": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemChestAche": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemBackAche": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemDizzle": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemPalpitation": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemBreatheHard": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemWeary": "0",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProplemMenstruation": "",//#0~2 身体其他疾病，数据越大，程度越强
        "bodyProblemOther": "",//#其他身体问题
        "medicalHistory": "",//#服药史，按名字匹配
        "healthCareProduct": "",//#保健品，按名字匹配
        "bloodPressureHigh": "",//#收缩血压
        "bloodPressureLow": "",//#舒张血压
        "heartRate": "",//#心率
        "spoz": "",//#血氧饱和度
        "bmi": "",
        "bloodSugar": "",//#血糖
        "bloodSugarTime": "",//#血糖测量时间
        "bloodFatTc": "",//#血脂六项
        "bloodFatTg": "",
        "bloodFatHdlC": "",
        "bloodFatLdlC": "",
        "bloodFatApoaI": "",
        "bloodFatApob": "",
        "bloodFatLpA": "",
        "cardiacMuscle3Ckmb": "",//#心肌三项
        "cardiacMuscle3Ctnl": "",
        "cardiacMuscle3Myo": "",
        "myocardialEnzymeLdh": "",//#心肌酶
        "myocardialEnzymeCk": "",
        "myocardialEnzymeHbdh": ""
      },
      //基础问询-后端格式
      has: {
        selectedParentsCad: [],
        selectedParentsMac: [],
        pastHighPress: "否",
        pastDiabetes: "否",
        pastHyperlipidemia: "否",
        pastFattyLiver: "否",
        pastCad: "否",
        pastStentImplantation: NoPastStentImplantation,
        hospitalConfirmedDiseasArr: [],
        pastOtherDisease: "", // 是否通过医院检查确认了，不在选项中的疾病
        relatedHospitalReportArr: ClinicReport,
        pastOtherRelatedDisease: "", // 其他相关领创检查报告，不在选项中的
        medicalHistory: MedicalHistory,
        healthCareProduct: "否",
      },
      model: {
        examUuid: "",
        dietAfterHour: true,
        stayUp: "",
        dietaryFavor: "",
        menstruation: "",
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
        mainSymptomFrequency: "",
        pastSymptomFrePlace: ""
      },
      rules: {
        sleepProblem: [
          { required: true, message: "请输入实际最大心率", trigger: "blur" }
        ],
      }
    };

  },
  computed: {
    otherHospitalConfirmedDiseasDisabled() {
      return !this.has.hospitalConfirmedDiseasArr.includes('其他')
    },
    otherRelatedReportDisabled() {
      console.log('********', !this.has.relatedHospitalReportArr.includes('其他'))
      return !this.has.relatedHospitalReportArr.includes('其他')
    },
    upload4Cospath() {
      return (type) => {
        return (baseURL + "/ExamService/uploadFile4Cos/" + this.examUuid + "/" + type + "/" + true);
      };
    }
  },
  watch: {
    'examBasicQuery.bloodPressureHigh':{
      handler(newVal, oldVal) {
        if(newVal.length > 0 && (newVal > 140 || newVal< 90)){
          this.showBloodPressureWarning = true
        } else {
          this.showBloodPressureWarning = false
        }
      }
    },
    'examBasicQuery.bloodPressureLow':{
      handler(newVal, oldVal) {
        if(newVal.length > 0 && (newVal > 89 || newVal< 60)){
          this.showBloodPressureWarning = true
        } else {
          this.showBloodPressureWarning = false
        }
      }
    },
    'examBasicQuery.heartRate':{
      handler(newVal, oldVal) {
        if(newVal.length > 0 && (newVal < 35 || newVal> 150)){
          this.showheartRateWarning = true
        } else {
          this.showheartRateWarning = false
        }
      }
    },
    'examBasicQuery.bloodSugar':{
      handler(newVal, oldVal) {
        if(newVal.length > 0 && (newVal > 14 || newVal< 5.5)){
          this.showBloodSugarWarning = true
        } else {
          this.showBloodSugarWarning = false
        }
      }
    },
    'bloodSugarTime':{
      handler(newVal, oldVal){
        this.examBasicQuery.bloodSugarTime = newVal
      }
    },
    'hadHeartOp': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.examBasicQuery.pastStentImplantation = JSON.stringify(NoPastStentImplantation)
        }
      }
    },
    'hadConfirmedDesease': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.examBasicQuery.hospitalConfirmedDiseas = ''
        }
      }
    },
    'hadClinlicReport': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.examBasicQuery.relatedHospitalReport = JSON.stringify(ClinicReport)
        }
      }
    },
    'has.selectedParentsCad': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.examBasicQuery.familyCad = newVal.join('^')
        } else {
          this.examBasicQuery.familyCad = ''
        }
      }
    },
    'has.selectedParentsMac': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.examBasicQuery.familyMac = newVal.join('^')
        } else {
          this.examBasicQuery.familyMac = ''
        }
      }
    },
    'has.pastHighPress': {
      handler(newVal, oldVal) {
        console.log('has pastHighPress changed')
        if (newVal === '否') {
          this.examBasicQuery.pastHighPress = ''
        } else if (newVal === '是') {
          this.examBasicQuery.pastHighPress = this.examBasicQuery.pastHighPress ? this.examBasicQuery.pastHighPress : '0'
        }
      }
    },
    'has.pastDiabetes': {
      handler(newVal, oldVal) {
        console.log('has pastDiabetes changed')
        if (newVal === '否') {
          this.examBasicQuery.pastDiabetes = ''
        } else if (newVal === '是') {
          this.examBasicQuery.pastDiabetes = this.examBasicQuery.pastDiabetes ? this.examBasicQuery.pastDiabetes : '0'
        }
      }
    },
    'has.pastHyperlipidemia': {
      handler(newVal, oldVal) {
        console.log('has pastHyperlipidemia changed')
        if (newVal === '否') {
          this.examBasicQuery.pastHyperlipidemia = ''
        } else if (newVal === '是') {
          this.examBasicQuery.pastHyperlipidemia = this.examBasicQuery.pastHyperlipidemia ? this.examBasicQuery.pastHyperlipidemia : '0'
        }
      }
    },
    'has.pastFattyLiver': {
      handler(newVal, oldVal) {
        console.log('has pastFattyLiver changed')
        if (newVal === '否') {
          this.examBasicQuery.pastFattyLiver = ''
        } else if (newVal === '是') {
          this.examBasicQuery.pastFattyLiver = this.examBasicQuery.pastFattyLiver ? this.examBasicQuery.pastFattyLiver : '0'
        }
      }
    },
    'has.pastCad': {
      handler(newVal, oldVal) {
        console.log('has pastCad changed')
        if (newVal === '否') {
          this.examBasicQuery.pastCad = ''
        } else if (newVal === '是') {
          this.examBasicQuery.pastCad = this.examBasicQuery.pastCad ? this.examBasicQuery.pastCad : '0'
        }
      }
    },
    'has.pastStentImplantation': {
      handler(newVal, oldVal) {
        console.log('has pastStentImplantation changed')
        if (newVal === null) {
          this.examBasicQuery.pastStentImplantation = JSON.stringify(NoPastStentImplantation)
        } else {
          this.examBasicQuery.pastStentImplantation = JSON.stringify(newVal)
        }
      },
      deep: true
    },
    'has.hospitalConfirmedDiseasArr': {
      handler(newVal, oldVal) {
        console.log('has hospitalConfirmedDiseasArr changed')
        if (!newVal.includes('其他')) this.has.pastOtherDisease = ''; // 没有选择其他是，清空其他的输入框
        if (this.has.pastOtherDisease) {
          this.examBasicQuery.hospitalConfirmedDiseas = newVal.join('^') + `^${this.has.pastOtherDisease}`
        } else {
          this.examBasicQuery.hospitalConfirmedDiseas = newVal.join('^')
        }
        console.log('this.examBasicQuery.hospitalConfirmedDiseas', this.examBasicQuery.hospitalConfirmedDiseas)
      }
    },
    'has.pastOtherDisease': { // 其他医院检查确诊的疾病
      handler(newVal, oldVal) {
        console.log('has pastOtherDisease changed')
        let arr = this.examBasicQuery.hospitalConfirmedDiseas.split('^')
        let temp = []
        let other, disease
        for (let i = 0; i < arr.length; i++) {
          disease = arr[i]
          if (hospitalConfirmedDiseasOptions.includes(disease)) {
            temp.push(disease)
          }
        }
        other = newVal
        if (other) temp.push(other)
        this.examBasicQuery.hospitalConfirmedDiseas = temp.join('^')
      }
    },
    'has.relatedHospitalReportArr': {
      handler(newVal, oldVal) {
        for (let i = 0; i < newVal.length; i++) {
          if (newVal[i].conclution || newVal[i].url) {
            this.hospitalExamReport.push(newVal[i].label)
          }
        }
        this.examBasicQuery.relatedHospitalReport = JSON.stringify(newVal)
      },
      deep: true
    },
    'has.pastOtherRelatedDisease': { // 其他医院检查确诊的疾病
      handler(newVal, oldVal) {
        console.log('has pastOtherDisease changed')
        let arr = this.examBasicQuery.relatedHospitalReport.split('^')
        let temp = []
        let other, disease
        for (let i = 0; i < arr.length; i++) {
          disease = arr[i]
          if (relatedHospitalReportOptions.includes(disease)) {
            temp.push(disease)
          }
        }
        other = newVal
        if (other) temp.push(other)
        this.examBasicQuery.relatedHospitalReport = temp.join('^')
        console.log('this.examBasicQuery.relatedHospitalReport', this.examBasicQuery.relatedHospitalReport)
      }
    },
    'has.medicalHistory': {
      handler(newVal, oldVal) {
        console.log('has medicalHistory changed')
        if (!newVal.had) {
          this.examBasicQuery.medicalHistory = JSON.stringify(MedicalHistory)
        } else {
          this.examBasicQuery.medicalHistory = JSON.stringify(newVal)
        }
      },
      deep: true
    },

    'has.healthCareProduct': {
      handler(newVal, oldVal) {
        console.log('has healthCareProduct changed')
        if (newVal === '否') {
          this.examBasicQuery.healthCareProduct = ''
        }
      }
    },
  },
  methods: {
    drinkingFreqChange(value) {
      if (value == "从不") {
        this.examBasicQuery.drinking.types = [];
      }
    },

    handleShowParentsCadChange(value) {
      if (!value) {
        this.has.selectedParentsCad = []
      }
    },
    handleShowParentsMacChange(value) {
      if (!value) {
        this.has.selectedParentsMac = []
      }
    },
    //获取基础问询
    _getExamBasicQuery() {
      getExamBasicQuery(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            this.model = res.data[0];
            // console.log('------------------------------')
            // console.log('------------------------------')
            // console.log('data--------------------------', res.data[0])
            //将数据转化为合适的格式后，赋值给examBasicQuery (这是前端展示的格式)
            this.examBasicQuery = res.data[0];

            this.preProcessGetData()
            // this.examBasicQuery = this.getConvertor(res.data[0]);
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
        // console.log("examBasicQuery", this.examBasicQuery);
      });
    },
    // 调用获取基础问询信息后，预处理数据，使其能正常显示于页面
    preProcessGetData() {
      window.abc = this.examBasicQuery
      window.has = this.has
      // 数据处理：控制流数据
      // 1. 既往病史
      this.examBasicQuery.familyCad = this.examBasicQuery.familyCad === "否" ? "" : this.examBasicQuery.familyCad
      this.examBasicQuery.familyMac = this.examBasicQuery.familyMac === "否" ? "" : this.examBasicQuery.familyMac
      this.showParentsCad = this.examBasicQuery.familyCad != "" ? true : false
      this.showParentsMac = this.examBasicQuery.familyMac != "" ? true : false

      this.examBasicQuery.familyCad != "" ? this.has.selectedParentsCad = this.examBasicQuery.familyCad.split('^') : this.has.selectedParentsCad = []
      this.examBasicQuery.pastHighPress != "" ? this.has.pastHighPress = "是" : this.has.pastHighPress = "否"
      this.examBasicQuery.pastDiabetes != "" ? this.has.pastDiabetes = "是" : this.has.pastDiabetes = "否"
      this.examBasicQuery.pastHyperlipidemia != "" ? this.has.pastHyperlipidemia = "是" : this.has.pastHyperlipidemia = "否"
      this.examBasicQuery.pastFattyLiver != "" ? this.has.pastFattyLiver = "是" : this.has.pastFattyLiver = "否"
      this.examBasicQuery.pastCad != "" ? this.has.pastCad = "是" : this.has.pastCad = "否"

      if (this.examBasicQuery.pastStentImplantation) {
        this.hadHeartOp = false
        let temp = JSON.parse(this.examBasicQuery.pastStentImplantation)
        // travel all the pastStentImplantation options, if all of them are 0, then set it to NoPastStentImplantation
        for (let key in temp) {
          if (temp[key] != 0) {
            this.hadHeartOp = true
            break
          }
        }
        this.has.pastStentImplantation = JSON.parse(this.examBasicQuery.pastStentImplantation)
      } else {
        this.hadHeartOp = false
        this.has.pastStentImplantation = NoPastStentImplantation
      }

      // this.examBasicQuery.pastOtherDiseas != "" ? this.has.pastOtherDiseas = "是" : this.has.pastOtherDiseas = "否"
      this.examBasicQuery.healthCareProduct != "" ? this.has.healthCareProduct = "是" : this.has.healthCareProduct = "否"

      // 预处理：明确诊断的某种疾病预处理--------------------------------------------
      let _hospitalConfirmedDiseasArr = this.examBasicQuery.hospitalConfirmedDiseas.split('^')
      let temp = [], disease = '', other = ''
      for (let i = 0; i < _hospitalConfirmedDiseasArr.length; i++) {
        disease = _hospitalConfirmedDiseasArr[i]
        if (hospitalConfirmedDiseasOptions.includes(disease)) { // 如果原始选项中有，就放入temp
          temp.push(disease)
        } else {
          other = disease
          temp.push('其他')
        }
      }
      this.has.hospitalConfirmedDiseasArr = Array.from(new Set(temp))
      this.has.pastOtherDisease = other
      // this.examBasicQuery.pastOtherDiseas += `^${other}`

      // 预处理：相关临床检查报告--------------------------------------------------------
      if (this.examBasicQuery.relatedHospitalReport) {
        this.examBasicQuery.relatedHospitalReport = JSON.stringify(ClinicReport)
        let _relatedHospitalReportArr = JSON.parse(this.examBasicQuery.relatedHospitalReport)
        for (let i = 0; i < _relatedHospitalReportArr.length; i++) {
          disease = _relatedHospitalReportArr[i]
          if (disease.conclution) {
            this.hadClinlicReport = true
            break
          }
        }
        this.has.relatedHospitalReportArr = _relatedHospitalReportArr
      } else {
        this.hadClinlicReport = false
        this.has.relatedHospitalReportArr = ClinicReport
      }

      //  服药史：药物名称处理
      if (this.examBasicQuery.medicalHistory) {
        this.has.medicalHistory = JSON.parse(this.examBasicQuery.medicalHistory)
      } else {
        this.has.medicalHistory = MedicalHistory
      }

      // // 保健品/药膳
      // let _medicalHistoryArr = this.examBasicQuery.medicalHistory.splite('^')
      // if (_medicalHistoryArr.length > 0) {
      //   this.has.medicalHistory = "是"
      //   this.has.medicalHistoryArr = _medicalHistoryArr
      // } else {
      //   this.has.medicalHistory = "否"
      //   this.has.medicalHistoryArr = []
      // }
    },
    //更新基础问询
    _updateExamBasicQuery() {
      const model = this.examBasicQuery;
      console.log(`has-pastHighPress : ${this.has.pastHighPress}----- pasHighPress: ${this.examBasicQuery.pastHighPress}`)
      this.model = this.postDataConvertor(this.examBasicQuery);

      this.submitting = true;
      updateExamBasicQuery(model)
        .then(
          (res) => {
            this.submitting = false;
            if (res.success) {
              this.$message({ message: res.description, type: "success" });
              //更新检查状态后，重新获取检查信息
              this._updateExamState(ExamStatesValue.BASIC_QUERY_30, this._getExamBasicQuery);
            } else {
              this.$message({
                message: res.description,
                type: "warning",
              });
            }
          }
        ).catch(e => {
          this.submitting = false;
          console.log(e)
        });
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    // data with typeof prop's value is string with splitter convert to Array
    getConvertor(data, direction, splitter = "^") {
      let convertedData = {
        examUuid: "",
        dietAfterHour: true,
        dietaryFavor: "",
        stayUp: "",
        menstruation: "",
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
        mainSymptomFrequency: "",
        pastSymptomFrePlace: ""
      };
      if (typeof data == "object") {
        for (let key in data) {
          let temp;
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "dietAfterHour":
              convertedData[key] = JSON.parse(data[key]);
              break;
            case "stayUp":
              convertedData[key] = data[key];
              break;
            case "menstruation":
              convertedData[key] = data[key];
              break;
            case "dietaryFavor":
              convertedData[key] = data[key];
              break;
            case "sleepRange":
              temp = data[key].split(splitter);
              convertedData[key] = {
                sleep: temp[0],
                getup: temp[1],
                total: temp[2],
              };
              break;
            case "sleepProblem":
              convertedData[key] = data[key].split(splitter);
              break;
            case "drinking":
              temp = data[key].split(splitter);
              if (temp.length <= 4) { // old msg type
                convertedData[key] = {
                  choice: temp[0],
                  year: temp[1],
                  frequency: temp[2],
                  volume: ""
                };

                if (temp.length > 3) {
                  convertedData[key].types = temp[3].split(',').filter(function (el) {
                    return el != "";
                  });
                }
                //考虑以前的数据 没有 饮酒类型时，将type设置为[]'
                else {
                  convertedData[key].types = [];
                }
                console.log('drinking-types', convertedData[key].types)
              } else {
                convertedData[key] = {
                  choice: temp[0],
                  year: temp[1],
                  frequency: temp[2],
                  volume: temp[3]
                };
                convertedData[key].types = temp[4].split(',').filter(function (el) {
                  return el != "";
                });
              }
              break;
            case "smoking":
              if (!data[key]) break;
              temp = data[key].split(splitter);
              convertedData[key] = {
                choice: temp[0],
                year: temp[1],
                frequency: temp[2],
                memo: temp[3] ? temp[3] : ""
              };
              break;
            case "sport":
              temp = data[key].split(splitter);
              if (temp.length >= 1 && temp[0] != "") {
                convertedData[key] = {
                  hasSport: true,
                  types: temp,
                };
              } else {
                convertedData[key] = {
                  hasSport: false,
                  types: [],
                };
              }
              break;
            case "currentSpirit":
              if (!data[key]) {
                convertedData[key] = [];
                break;
              }
              temp = data[key].split(splitter);
              convertedData[key] = temp;
              break;
            case "personalityType":
              convertedData[key] = data[key];
              break;
            case "mostBother":
              convertedData[key] = data[key];
              break;
            case "mainSymptomFrequency":
              if (!data[key]) {
                convertedData[key] = {
                  place: "无",
                  frequence: "极少数（以前或者现在出现1-2次）"
                };
                break;
              }
              temp = data[key].split(splitter);
              convertedData[key] = {
                place: temp[0],
                frequence: temp[1]
              };
              break;
            case "pastSymptomFrePlace":
              if (!data[key]) {
                convertedData[key] = {
                  place: "无"
                };
                break;
              }
              temp = data[key].split(splitter);
              convertedData[key] = {
                place: temp[0],
                frequence: temp[1],
                organ: temp[2]
              };
              break;
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // data with typeof prop's value is Array convert to string with splitter
    postDataConvertor(data, splitter = "^") {
      let convertedData = {
        examUuid: "",
        dietAfterHour: true,
        dietaryFavor: "",
        stayUp: "",
        menstruation: "",
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
        pastSymptomFrePlace: "",
        mainSymptomFrequency: ""
      };
      if (typeof data == "object") {
        for (let key in data) {
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "dietAfterHour":
              convertedData[key] = data[key];
              break;
            case "stayUp":
              convertedData[key] = data[key];
              break;
            case "menstruation":
              convertedData[key] = data[key];
              break;
            case "dietaryFavor":
              convertedData[key] = data[key];
              break;
            case "sleepRange":
              convertedData[key] =
                data[key].sleep +
                splitter +
                data[key].getup +
                splitter +
                data[key].total;
              break;
            case "sleepProblem":
              convertedData[key] = data[key].join(splitter);
              break;
            case "drinking":
              convertedData[key] =
                data[key].choice +
                splitter +
                data[key].year +
                splitter +
                data[key].frequency +
                splitter +
                data[key].volume +
                splitter +
                data[key].types.join(",");
              break;
            case "smoking":
              convertedData[key] = data[key].choice + splitter + data[key].year + splitter + data[key].frequency + splitter + data[key].memo;
              break;
            case "sport":
              if (data[key].hasSport) {
                convertedData[key] = data[key].types.join(splitter);
              } else {
                convertedData[key] = "";
              }
              break;
            case "currentSpirit":
              convertedData[key] = data[key].join(splitter);
              break;
            case "personalityType":
              convertedData[key] = data[key];
              break;
            case "mostBother":
              convertedData[key] = data[key];
              break;
            case "mainSymptomFrequency":
              convertedData[key] = data[key].place + splitter + data[key].frequence;
              break;
            case "pastSymptomFrePlace":
              convertedData[key] = data[key].place + splitter + data[key].frequence + splitter + data[key].organ;
              break;
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // test two Object is Indentical: (props are basic data types)
    ObectIdenticalTest(obj1, obj2) {
      let flag = true;
      for (let key in obj1) {
        // if(obj1[key] )
        if (obj1[key] != obj2[key]) {
          flag = false;
          return flag;
        }
      }
      for (let key in obj2) {
        if (obj2[key] != obj1[key]) {
          flag = false;
          return flag;
        }
      }
      return flag;
    },

  },
  mounted() {
    this.examBasicQuery.examUuid = this.examUuid;
    this.model.examUuid = this.examUuid;
    this._getExamBasicQuery();
  },
};
</script>

<style scoped>
.small-input {
  width: 70px;
}

.large-input {
  width: 140px;
}

.fullWidth {
  width: 100%;
}

.fr {
  float: right;
}

.fl {
  float: left;
}

.indent {
  margin-left: 36px;
  font-size: 14px
}

.text-center {
  text-align: center
}

.ml15 {
  margin-left: 15px;
}

.container {
  display: flex;
  align-items: center;
  gap: 32px;
  /* Align items vertically in the center */
}

.checkbox-container {
  display: flex;
  flex-direction: column;
}

.checkbox-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  /* Optional: Adds space between items */
}

.column-checkbox-group .row-checkbox {
  display: block;
  /* Ensures checkboxes are displayed as block elements, stacking them vertically */
  margin-bottom: 10px;
  /* Adds spacing between each checkbox */
}

.row-checkbox .row-content {
  display: flex;
  /* Use flexbox to layout children elements in a row */
  align-items: center;
  /* Vertically center align items */
}

.checkbox-label {
  width: 120px;
  /* Set a fixed width for labels to align consistently */
  flex-shrink: 0;
  /* Prevent the label from shrinking */
}

.conclusion-input {
  margin-left: 10px;
  /* Space between the label and the input */
  flex: 1;
  /* Allow the input to take available space */
  min-width: 450px;
}

.report-link {
  margin-left: 10px;
  /* Space between the input and the link */
}

.upload-button {
  margin-left: 10px;
  /* Space between adjacent components and the upload button */
}

.el-upload .el-button {
  margin: 0;
  /* Remove extra margin from the button */
}

::v-deep .no-spinner input::-webkit-outer-spin-button,
::v-deep .no-spinner input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
